  import PageContainer from '@/components/PageContainer';

  import { patientCrud, testCrud, userCrud } from '@/services/firebase';
  import { ClinicAdmin, Patient, Test, Token } from '@/types/database';
  import { useOutletContext } from 'react-router-dom';
  import { Timestamp } from 'firebase/firestore';
  import { Typography } from '@mui/material';
  import { RouteContext } from './types';
  import { useEffect } from 'react';
  import { sendEmail } from '@/services';

  export default function CompletedPage() {
    const { data, id, testData, patientData } = useOutletContext<RouteContext>();

    useEffect(() => {
      const now = Timestamp.now();
      if (!testData || !patientData) return;

      const test: Partial<Test> = {
        completedAt: now,
        status: 'submitted',
      };

      testCrud.update(id as string, test);

      const patientProps: Partial<Patient> = { status: 'submitted' };
      const surgeryDescription = testData?.answer?.['surgeryDescription'] || '';
      if (surgeryDescription) {
        patientProps.description = surgeryDescription;
      }

      patientCrud.update(testData.patientId, patientProps);

      const accessTokens = patientData?.accessTokens.filter((token: Token) => token.resourceId !== id);

      patientCrud.update(testData.patientId, {
        accessTokens,
      });

      (userCrud.read([['managedClinicId', '==', patientData.clinicId], ['role', '==', 'clinic-admin']]) as Promise<ClinicAdmin[]>).then((clinicAdmins: ClinicAdmin[]) => {
        const clinicAdmin = clinicAdmins[0] ||  clinicAdmins;
        sendEmail({to: clinicAdmin.email, templateName: 'clinic-admin-exam-complete', props: {name: clinicAdmin.name, patientLastName: patientData.lastName, patientDOB: patientData.dob?.toDate().toLocaleString('en-US').split(',')[0] || ''}});
      });

    }, [data, id, testData, patientData]);

    return (
      <PageContainer title="Exam Complete!" description="<br/>Guess What? You’re done!">
        <Typography variant="body1" gutterBottom>
          An anesthesiologist will personally review your examination and contact you if there are any concerns.
        </Typography>
        <Typography my={3} variant="body1" gutterBottom>
          Don’t worry if you haven’t been contacted, it just means that everything looks good!
        </Typography>
        <Typography variant="body1" gutterBottom>
          You did spectacular, good luck with your surgery, you’re gonna do great.
        </Typography>
      </PageContainer>
    );
  }
